<div class="header-menu is-not-mobile">
  @if (userList$ | async; as userList) {
    <button
      mat-stroked-button
      color="secondary"
      class="rounded header-menu__sign"
      (click)="toggleMenu()">
      <sharry-icon
        matIconPrefix
        registryName="list"></sharry-icon>
      @if (!!userList.user) {
        <span
          [avatar]="{
            size: 'small',
            imgSize: '36px',
            user: userList.user ? userList.user : undefined,
            imgValueUrl: userList.user ? undefined : '',
            noBorder: !userList.user,
          }"></span>
        @if (totalUnread$ | async; as pinValue) {
          <span class="not-read-pin not-read-pin--header">
            {{ pinValue < 10 ? pinValue : '9+' }}
          </span>
        }
      } @else {
        <sharry-icon
          svgClass="svg-icon"
          registryName="user-circle"></sharry-icon>
      }
    </button>
    <nav
      #menu
      class="header-menu__menu"
      [ngClass]="{ hidden: !menuOpened }"
      (click)="toggleMenu()">
      <span
        class="header-menu__menu__arrow"
        [ngStyle]="{ background: userList.user ? '#FCFAFF' : null }"></span>
      <div class="header-menu__menu__wrapper">
        <ul
          class="header-menu__menu__user"
          (click)="$event.stopPropagation(); $event.stopImmediatePropagation()">
          @for (list of userList.list; track list; let last = $last) {
            <div
              class="header-menu__menu__user--wrapper"
              [ngClass]="{
                'header-menu__menu__user--wrapper--no-pd-bottom':
                  list[0]?.class === 'main-routes' || list[0]?.class === 'auth-routes',
              }">
              @for (item of list; track item.text) {
                @if (item.title) {
                  <p>{{ item.title | i18next }}</p>
                }
                <li [class]="'header-menu__menu__user--' + item.class">
                  @if (item.class === 'auth-routes') {
                    @if (item.text === 'header.sign-up') {
                      <a
                        [routerLink]="item.route.length ? (item.route | routeTranslate) : []"
                        [queryParams]="item.routeParams"
                        [class]="'header-menu__menu__user--' + item.class + '--signin'"
                        (click)="toggleMenu(item)"
                        >{{ item.text | i18next }}</a
                      >
                    } @else {
                      <p>
                        {{ 'sign-in.already-have-account' | i18next }}
                      </p>
                      <div class="tag--signin">
                        <a
                          [routerLink]="item.route.length ? (item.route | routeTranslate) : []"
                          [queryParams]="item.routeParams"
                          (click)="toggleMenu(item)"
                          >{{ item.text | i18next }}</a
                        >
                      </div>
                    }
                  } @else {
                    @if (item.route) {
                      <a
                        [routerLink]="item.route.length ? (item.route | routeTranslate) : []"
                        [queryParams]="item.routeParams"
                        [ngClass]="{ active: item.active }"
                        (click)="toggleMenu(item)">
                        <ng-container *ngTemplateOutlet="iconsTemplate"></ng-container>
                        {{ item.text | i18next }}
                        @if (item.pinValue$ | async; as pinValue) {
                          <span class="not-read-pin">
                            {{ pinValue < 10 ? pinValue : '9+' }}
                          </span>
                        }
                      </a>
                    } @else {
                      <button
                        type="button"
                        (click)="item.handler(); toggleMenu(item)">
                        <ng-container *ngTemplateOutlet="iconsTemplate"></ng-container>
                        {{ item.text | i18next }}
                      </button>
                    }
                  }
                </li>
                <ng-template #iconsTemplate>
                  @if (item.icon) {
                    <sharry-icon
                      svgClass="svg-icon"
                      [registryName]="item.icon"></sharry-icon>
                  }
                  @if (item.avatar) {
                    <div [avatar]="{ user: userList.user, size: 'small', imgSize: '22px' }"></div>
                  }
                  @if (item.image) {
                    <img
                      height="22px"
                      width="22px"
                      class="custom-icons"
                      alt="link image"
                      [src]="item.image" />
                  }
                </ng-template>
              }
            </div>
            @if (!last && list[0]?.class !== 'main-routes' && list[0]?.class !== 'auth-routes') {
              <div class="divider"></div>
            }
          }
        </ul>
      </div>
    </nav>
  }
</div>
